import type { Sequence } from '@/types/api'

/**
 * An active sequence with pending enrollments but no sender account:
 * the scheduler silently skips every send until an email account is connected.
 */
export function isSendBlocked(sequence: Sequence): boolean {
  return (
    sequence.status === 'active' &&
    !sequence.email_account_id &&
    (sequence.enrollments_count ?? 0) > 0
  )
}

/**
 * Oggetto che riceve il destinatario, stessa regola di `resolve_step_subject`
 * nel motore di invio (#264): un follow-up risponde nello stesso thread con
 * `Re: <oggetto del primo step>` e il suo oggetto non viene usato. Senza
 * `firstSubject` (primo step, o primo step senza oggetto) vale l'oggetto dello
 * step. Serve solo per mostrare il template dell'oggetto che riceve il
 * destinatario (scheda dello step, avviso nell'editor): l'anteprima, anche con
 * i dati di esempio, riceve dal server l'oggetto già risolto e renderizzato (#265).
 */
export function resolveStepSubject(subject: string, firstSubject?: string): string {
  return firstSubject ? `Re: ${firstSubject.replace(/^(Re:\s*)+/i, '')}` : subject
}
